









import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Order } from "@/models/order";
import { Invoice } from "@/models/invoice";
import { Mutation } from "vuex-class";
import TableJson from "@/components/TableJSON.vue";

@Component({
  components: {
    TableJson
  }
})
export default class RawExpand extends Vue {
  @Prop() public value: any;
}
